import { StringId } from '../localizer/stringId'

export const strings = {
  [StringId.DV_DP_first_review]: 'Be the first to review this item',
  [StringId.DV_DP_title_num_of_seasons_one]: '{numOfSeasons} Season',
  [StringId.DV_DP_title_num_of_seasons_few]: '{numOfSeasons} Seasons',
  [StringId.DV_DP_title_num_of_seasons_many]: '{numOfSeasons} Seasons',
  [StringId.DV_DP_title_num_of_seasons_other]: '{numOfSeasons} Seasons',
  [StringId.DV_DP_ARIA_amazon_rating]: 'Rated {ratingValue} out of 5 stars by {customerCount} Amazon customers, click to view the customer reviews',
  [StringId.DV_DP_ARIA_imdb_rating]: 'IMDb Rating {ratingValue}',
  [StringId.DV_DP_ARIA_watch_episode]: 'Watch episode {episodeNumber}, {episodeTitle}',
  [StringId.DV_DP_ARIA_watch_title]: 'Watch {title}',
  [StringId.DV_DP_ARIA_audio_description]: 'Audio Description'
}